import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Getter, Mutation } from "vuex-class";

// External components
import ModalBase from "../modalBase/modalBase";
import Carousel from "../carousel/carousel";

// Helpers
import { localCurrency } from "@/plugins/currency";
@Component({
  components: { ModalBase, Carousel },
  methods: { localCurrency },
})
export default class IngredientModal extends Vue {
  @Prop({ default: false }) isActive;
  @Prop({ default: null }) selectedDish;
  @Prop({ default: true }) isShowingChangeIngredientButton;

  @Getter getMealIngredients;

  @Mutation SET_INGREDIENT_TO_REPLACE;

  selectedIngredient = null;

  get selectedIngredientPicture() {
    if (this.selectedIngredient) {
      const { img } = this.selectedIngredient;
      if (img.url) return img.url;
      else
        return "https://s3.us-east-1.amazonaws.com/mimenu.todoscomemos.com/imgs/icons/Empty-product.svg";
    }
    return "https://s3.us-east-1.amazonaws.com/mimenu.todoscomemos.com/imgs/icons/Empty-product.svg";
  }

  get selectedIngredientIndex() {
    if (this.selectedDishItems.length) {
      return this.selectedDishItems.findIndex(
        (item) => item.menu_items_product_id === this.selectedIngredient.menu_items_product_id
      );
    }
  }

  get selectedDishItems() {
    if (this.selectedDish) {
      const { product_menu_items, items } = this.selectedDish;
      if (product_menu_items) return product_menu_items;
      else if (items) return items;
    }
    return [];
  }

  mounted() {
    this.selectDefaultIngredient();
  }

  @Watch("selectedDish")
  onSelectDish() {
    this.selectDefaultIngredient();
  }

  selectDefaultIngredient() {
    this.selectedIngredient = this.selectedDishItems[0];
  }

  setNextIngredient() {
    if (this.selectedIngredientIndex === this.selectedDishItems.length - 1) {
      this.selectedIngredient = this.selectedDishItems[0];
    } else {
      this.selectedIngredient = this.selectedDishItems[this.selectedIngredientIndex + 1];
    }
  }

  setPreviousIngredient() {
    if (this.selectedIngredientIndex === 0) {
      this.selectedIngredient = this.selectedDishItems[this.selectedDishItems.length - 1];
    } else {
      this.selectedIngredient = this.selectedDishItems[this.selectedIngredientIndex - 1];
    }
  }

  changeIngredient() {
    const { count_id, menu_id, menu_option_id } = this.selectedDish;
    this.SET_INGREDIENT_TO_REPLACE({
      ...this.selectedIngredient,
      count_id,
      menu_id,
      menu_option_id,
    });
    this.$router.push({
      name: "changeProduct",
      params: {
        menu_id,
        menu_option_id,
        count_id,
        menu_item_id: this.selectedIngredient.menu_item_id,
      },
    });
  }
}
